import { FC } from "react";
import { lang } from "../../models";
import "./FilterMenu.scss";
import { useTranslation } from "react-i18next";
import Dropdown from "../../CustomComponent/DynamicDropDown/DynamicDropdown";
import ReportCustomInput from "../../CustomComponent/CustomInput/CustomInput";
import { handleLangugeDirection } from "../../components/commonFunctions";

interface FilterMenuProps {
  children?: React.ReactNode;
  closeMenu: ((show: boolean) => void) | any;
  menuTitle: string;
  onApplyClick?: (addValue: any) => void;
  ApplyContent?: any;
  addInputProps?: any;
  handleFilterChange?: (name: string, value: any) => void;
  role?: string;
  isMulti?: boolean;
}
const FilterMenu: FC<FilterMenuProps> = ({
  children,
  closeMenu,
  menuTitle,
  onApplyClick,
  ApplyContent,
  addInputProps,
  handleFilterChange,
  role,
  isMulti = true,
}) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "FilterpageComponent",
  });

  const InputAddElements = () => {
    const handleChange = (name: string, value: any) => {
      if (handleFilterChange) {
        handleFilterChange(name, value);
      }
    };
    return addInputProps.map((res: any, index: number) => {
      if (res.inputType === "input") {
        return (
          <ReportCustomInput
            key={index}
            {...res}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              handleChange(e.target.name, e.target.value);
            }}
          />
        );
      } else if (res?.inputType === "select") {
        return (
          <Dropdown
            isSearchable
            isMulti={isMulti}
            placeHolder="Select..."
            options={res?.options}
            values={isMulti ? res?.value : res?.value?.[0] ?? null}
            inputLabel={res?.inputLabel}
            onChange={(
              selected:
                | { label: string; value: string }
                | { label: string; value: string }[]
                | null
            ) => {
              const normalizedArray = Array.isArray(selected)
                ? selected.map((o) => ({ value: o.value, label: o.label }))
                : selected
                ? [{ value: selected.value, label: selected.label }]
                : [];

              handleChange(res.name, normalizedArray);
            }}
            width="100%"
            key={res.id}
          />
        );
      } else {
        return null;
      }
    });
  };

  return (
    <div
      className="filter-Menu"
      style={
        handleLangugeDirection(
          lang,
          "dropdown__window"
        ) /* lang === "en" ||lang === "fr"? { right: "0px" } : { left: "0px" } */
      }
    >
      <div className="filter-header">
        <p className="text"> {menuTitle} </p>
      </div>
      <div className="filter-content px-1">
        <div className="element-content">
          {addInputProps && InputAddElements()}
          {children}
        </div>

        <div className="filter-buttons">
          <button className="button-secondary-light" onClick={closeMenu}>
            {" "}
            {t("cancel")}{" "}
          </button>
          <button className="button-primary-dark" onClick={onApplyClick}>
            {" "}
            {ApplyContent}{" "}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilterMenu;
